import React from 'react';
import { Dayjs } from 'dayjs';
import { Box, HintText, Text, Stack } from '@mos-cat/ds';
import { VisuallyHidden } from 'reakit';

import OutageBlock from '../common/OutageBlock';
import DaysCalendar from './DaysCalendar';
import { convertDateToFriendlyFormat, getPluralizedDiffInDays } from '../../../../helpers/date';

type Props = {
  dateFrom: Dayjs;
  dateTo: Dayjs;
};

// typograf-enable
export default function OutageInFuture({ dateFrom, dateTo }: Props) {
  const formattedDateFrom = convertDateToFriendlyFormat(dateFrom);
  const formattedDateTo = convertDateToFriendlyFormat(dateTo);
  const period = `${formattedDateFrom} — ${formattedDateTo}`;
  const pluralizedDiffInDays = getPluralizedDiffInDays(dateFrom, dateTo);
  return (
    <OutageBlock
      heading={
        <Text>
          <VisuallyHidden>Отключение с </VisuallyHidden>
          {formattedDateFrom}{' '}
          <Text>
            <VisuallyHidden>по</VisuallyHidden>
            <Text aria-hidden>&mdash;</Text>
          </Text>{' '}
          {formattedDateTo}
        </Text>
      }
    >
      <Box>
        {!!pluralizedDiffInDays && (
          <Stack mt="sp-12">
            <HintText>Период отключения</HintText>
            <Text>{pluralizedDiffInDays}</Text>
          </Stack>
        )}
        <Box mt="sp-24">
          <DaysCalendar dateFrom={dateFrom} dateTo={dateTo} period={period} />
        </Box>
      </Box>
    </OutageBlock>
  );
}
